import React, {Component} from 'react';
import {Translation} from 'react-i18next';
import {Card, Col, Row, Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';

import UserAccountForm from '../containers/UserAccountFormContainer';
import UpdatePasswordForm from '../containers/UpdatePasswordFormContainer';
import TwoFactorSettingsForm from '../containers/TwoFactorSettingsFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class UserAccountScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `UserAccountScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    const loadingIcon = <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />;
    return (
      <Translation>{(t) => 
        <div>

          <DocumentHead title={t('user_account_route')} />

          <Row gutter={24}>

            <Col lg={24} xl={12}>
              <Card title={t('user_account_form_title')} extra={this.props.isLoading ? loadingIcon : null}>
                <UserAccountForm />
              </Card>
            </Col>

            <Col lg={24} xl={12}>

              <Card title={t('password_form_title')}>
                <UpdatePasswordForm />
              </Card>

              {this.props.oneTimePassword === 2
                ? <Card title={t('user_account_2fa_form_title')} extra={this.props.isSubmitting2FA ? loadingIcon : null}>
                    <TwoFactorSettingsForm />
                  </Card>
                : null}
              
            </Col>

          </Row>

        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    Logger.log('silly', `UserAccountScreen.componentDidMount()`);
    this.scrollToTop();
  }

  componentDidUpdate() {
    Logger.log('silly', `UserAccountScreen.componentDidUpdate()`);
  }

  componentWillUnmount() {
    Logger.log('silly', `UserAccountScreen.componentWillUnmount()`);
  }
}

export default UserAccountScreen;

Logger.log('silly', `UserAccountScreen loaded.`);
